<template>
  <div class="information-recommend-card">
    <div class="file-icon-box">
      <img class="file-icon" :src="fileIcon" />
      <div class="recently" v-if="info.is_recently">上 次 查 看</div>
    </div>
    <div class="info">
      <div class="title">{{ index + 1 }}.{{ info.title }}</div>
      <div class="bottom">
        <img class="app-logo" :src="info.app_logo" />
        <div class="app-name">{{ info.app_name }}</div>
        <div class="read">{{ info.read_num }}阅读量·</div>

        <div class="time">{{ info.release_time.slice(0, 10) }}</div>
      </div>
    </div>
    <img v-if="info.is_vip" class="vip" src="@/assets/icon/vip.png" />
  </div>
</template>

<script>
import { getFileIcon, getFileType } from "@/common/util";
export default {
  name: "InformationCollectionCard",
  props: {
    info: {
      type: Object,
      default: (_) => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    fileType() {
      return getFileType(this.info.url || "");
    },
    fileIcon() {
      return getFileIcon(`${this.fileType}_bg`);
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.information-recommend-card {
  width: calc(100% - 80px);
  display: flex;
  align-items: center;
  background-color: white;
  padding: 20px 60px 20px 20px;
  cursor: default;
  position: relative;
  .file-icon-box {
    width: 85px;
    height: 85px;
    position: relative;
    .file-icon {
      width: 100%;
      height: 100%;
    }
    .recently {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      font-size: 18px;
      text-align: center;
      box-sizing: border-box;
      padding: 20px;
    }
  }
  .info {
    height: 80px;
    width: calc(100% - 100px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
    .title {
      font-size: 16px;
      font-weight: 400;
      color: #222222;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-wrap: break-word;
    }
    .bottom {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      .app-logo {
        width: 18px;
        height: 18px;
        border-radius: 50%;
      }
      .app-name {
        margin-left: 5px;
        height: 18px;
        white-space: nowrap;
      }
      .read {
        margin-left: 5px;
        height: 18px;
        white-space: nowrap;
      }
      .time {
        height: 18px;
        white-space: nowrap;
      }
    }
  }
  .vip {
    border-radius: 2px;
    height: 17px;
    width: 36px;
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
</style>
